import { FC, useRef, useState } from "react";
import { useOnClickOutside } from "src/hooks/useClickOutside";

type PracticeContactInfoProps = {
  name: string;
  address: string;
  phone: string | number;
  fax: string | number;
  children: JSX.Element;
  indexKey: number;
};

/**
 * Inline fallback for the practice-details hover tooltip (title attribute) on
 * MD/provider names. Hidden on hover-capable devices; shown on touch devices
 * (iPad/phones) via the global .touch-only rule in generic.scss, where the
 * title tooltip can never be triggered.
 */
const PracticeContactInfo: FC<PracticeContactInfoProps> = ({ name, address, phone, fax, children, indexKey }) => {
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);
  const { position } = useOnClickOutside(toggleIconRef, () => changeInfoIconIndex(-1))
  const tooltipText = `Name: ${name}\n\nAddress: ${address}\n\nPhone: ${phone}\n\nFax: ${fax}`

  return (
    <span 
      className="btn btn-link p-0 info-icon user-select-text"
      title={tooltipText}
      onClick={() => changeInfoIconIndex(infoIconIndex !== (indexKey ?? 0) ? (indexKey ?? 0) : -1)}
      ref={toggleIconRef}
    >
      {children}
      <div
        className={`info-icon-detail bg-dark ${position && (infoIconIndex === indexKey) ? "d-block" : "d-none"} user-select-text`}
        style={{ top: position.top, left: position.left }}
        dangerouslySetInnerHTML={{
          __html: `<p class="m-0 text-white text-start">Name: ${name}</p><p class="m-0 text-white text-start">Address: ${address}</p><p class="m-0 text-white text-start">Phone: ${phone}</p><p class="m-0 text-white text-start">Fax: ${fax}</p>`
        }}
      ></div>
    </span>
  );
}

export default PracticeContactInfo;
